import { TColors } from '@cian/ui-kit-design-tokens/colors';
import { IconToggleHeartOn12, IconFinancePercent12 } from '@cian/ui-kit-design-tokens/icons';
import { renderToStaticMarkup } from 'react-dom/server';

interface IIconProps {
  isFavorite?: boolean;
  isPromo?: boolean;
  isActive?: boolean;
  isViewed?: boolean;
}

export const Icon: React.FC<IIconProps> = ({ isFavorite, isPromo, isActive, isViewed }) => {
  if (isFavorite) {
    return <IconToggleHeartOn12 color={isActive ? 'icon-on-bright-default' : 'icon-negative-default'} />;
  }

  if (isPromo) {
    let color: TColors = isViewed ? 'icon-primary-disabled' : 'icon-positive-default';
    if (isActive) {
      color = 'icon-inverted-default';
    }

    return <IconFinancePercent12 color={color} />;
  }

  return null;
};

export const getIcon = (props: IIconProps) => renderToStaticMarkup(<Icon {...props} />);
